import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { Form } from "react-bootstrap";
import { InputComponentProps } from "components/molecules/RenderPollQuestion/RenderPollQuestion";

export default function TextareaInput({
  question,
  nextPageClicked,
  defaultValue,
  readOnly,
}: InputComponentProps) {
  const {
    register,
    formState: { errors, isSubmitted },
    getValues,
    setValue,
  } = useFormContext();

  const validationMeta = question?.meta.find(
    (meta) => meta.key === "validation"
  );
  const requiredMessage = validationMeta
    ? JSON.parse(validationMeta.value).requiredMessage
    : "";
  const minLength = validationMeta
    ? JSON.parse(validationMeta.value).minLength
    : 0;
  const maxLength = validationMeta
    ? JSON.parse(validationMeta.value).maxLength
    : 0;
  const minLengthMessage = validationMeta
    ? JSON.parse(validationMeta.value).minLengthMessage
    : "";
  const maxLengthMessage = validationMeta
    ? JSON.parse(validationMeta.value).maxLengthMessage
    : "";

  const tooltip = question?.meta.find(
    (meta) => meta.key === "html_tooltip"
  )?.value;

  useEffect(() => {
    if (defaultValue !== undefined) {
      setValue(question?.fieldName, defaultValue);
    }
  }, [defaultValue, setValue, question?.fieldName]);

  useEffect(() => {
    const value = getValues(question?.fieldName);
    setValue(question?.fieldName, value, { shouldValidate: true });
  }, [getValues, setValue, question?.fieldName]);

  const fieldSizeMeta = question?.meta?.find((m) => m.key === "field_size");
  const fieldSize = fieldSizeMeta ? JSON.parse(fieldSizeMeta.value).lg : "12";
  return (
    <div className={`mb-2 mt-2 col-lg-${fieldSize}`}>
      <div>
        {question?.question && (
          <Form.Label className="fw-600 fs-16 mb-0">
            {question?.question}
            {validationMeta && JSON.parse(validationMeta.value).isRequired && (
              <span className="text-validation">*</span>
            )}
          </Form.Label>
        )}
        <p>{question?.description}</p>
      </div>
      <Form.Control
        as="textarea"
        className={`form-control ${
          errors[question?.fieldName] ? "input-error" : ""
        }`}
        {...register(question?.fieldName, {
          required: requiredMessage,
          minLength: minLength
            ? { value: minLength, message: minLengthMessage }
            : undefined,
          maxLength: maxLength
            ? { value: maxLength, message: maxLengthMessage }
            : undefined,
        })}
        defaultValue={getValues(question?.fieldName)}
        isInvalid={isSubmitted && !!errors[question?.fieldName]}
        disabled={readOnly}
      />
      {tooltip && (
        <div
          className="fs-12 fw-400"
          dangerouslySetInnerHTML={{ __html: tooltip }}
        />
      )}
      {(nextPageClicked || isSubmitted) && errors[question?.fieldName] && (
        <ErrorMessage
          errors={errors}
          name={question?.fieldName}
          render={({ message }) => (
            <div className="text-validation">{message}</div>
          )}
        />
      )}
      {question?.description && (
        <div
          className="mt-1"
          dangerouslySetInnerHTML={{ __html: question?.description || "" }}
        ></div>
      )}
    </div>
  );
}
